import {CustomTag, CustomTagsGateway, TagType} from "@livechat/tags";
import {UseCase} from "@livechat/shared";
import {map, Observable} from "rxjs";

export class ListCustomTagsUseCase implements UseCase<{ companiesId: string[] }, Observable<CustomTag[]>> {
  constructor(private tagsGateway: CustomTagsGateway) {
  }

  execute(params: { companiesId: string[] }): Observable<CustomTag[]> {
    return this.tagsGateway.list(params)
      .pipe(map(tags => tags.filter(({type}) => type === TagType.CUSTOM)))
  }
}
